import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class DocumentProductRecordDetail extends Component {
  state = {
    pageTitle: "Müşteriden Ürün Bilgi/Belge İstenmesi Detay (ÜTS Ürün Kaydı)",
    pageTitleDetail: "Müşteri Ürün Belge Talep Detay (ÜTS Ürün Kaydı)",
    pageAddLink: "musteri-urun-belge-talep-ekle",
    pageListLink: "musteri-urun-belge-talep-listele",
    breadcrumb: [{ text: "Müşteriden Ürün Bilgi/Belge İstenmesi", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    customerName: "",
    status: "",
    offerDate: "",
    offerTotal: "",
    currencyType: "",
    description: "",
    createdBy: "",
    statusMail: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        //pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/documentProductRecords/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            customerName: response.data.customerName,
            description: response.data.description,
            status: response.data.status,
            offerTotal: response.data.offerTotal,
            offerDate: response.data.offerDate,
            currencyType: response.data.currencyType,
            statusMail: response.data.statusMail,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  name="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Müşteri</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Teklif Bilgileri</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.offerDate + "-" + this.state.offerTotal + " " + (this.state.currencyType === 1 ? "TL" : this.state.currencyType === 2 ? "$" : 
                      this.state.currencyType === 3 ? "€" : "")} 
                    </td> 
                  </tr>
               <tr>
                  <th>Açıklama</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.description !== "" ? this.state.description : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>E-mail Durumu</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.state.statusMail === 1 ? "E-mail Gönderilsin" : "E-mail Gönderilmesin !"}</td>
                  </tr>

                  <tr>
                    <th>Durum</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default DocumentProductRecordDetail;
